import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});
// instance.interceptors.request.use(async (config) => {
// config.params = config.params || {};

// const method = config.method?.toLowerCase();
// const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");

// if (needsCsrf) {
// const res = await instance.get("/api/csrf-token");
// config.headers["X-CSRF-Token"] = res.data.csrfToken;
// }

// return config;
// });
const ApiInterceptor = () => {
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        if (error.config) {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );
  return null;
};
ApiInterceptor();
const apiRequest = {
  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor-manager/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor-manager/${v}/sendOtp`, body),
  resetPassword: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor-manager/${v}/resetPassword`, body),

  verifyOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor-manager/${v}/verifyOtp`, body),

  getDashboardData: ({ v = "v1" } = {}) =>
    instance.get(`/api/vendor-manager/${v}/getDashboardData`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  editProductImage: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(
      `/api/vendor-manager/${v}/product/productImage/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
        },
      }
    ),
      updateProductStatus: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/vendor-manager/${v}/product/status-update/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),
  createProduct: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor-manager/${v}/create-product`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  updateProduct: ({ v = "v1", id, body } = {}) =>
    instance.put(`/api/vendor-manager/${v}/product/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  getMainCategory: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor-manager/${v}/get-main-category`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  deleteProduct: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/vendor-manager/${v}/product/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  getProfile: ({ v = "v1" } = {}) =>
    instance.post(
      `/api/vendor-manager/${v}/profile`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
        },
      }
    ),

  getServerInfo: ({ v = "v1" } = {}) =>
    instance.get(`/api/vendor-manager/${v}/serverInfo`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),
  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor-manager/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  getProducts: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor-manager/${v}/getProducts`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),
  getVendorOrders: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor-manager/${v}/orders`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),
  getVendorScanOrders: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor-manager/${v}/getVendorScanOrders`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  getOrderedDetail: ({ v = "v1", id } = {}) =>
    instance.get(`/api/vendor-manager/${v}/getOrderedDetail/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),
  updateOrderStatus: ({ v = "v1", id, body } = {}) =>
    instance.put(`/api/vendor-manager/${v}/updateOrderStatus/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  getExcelImportList: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/vendor-manager/${v}/excel/imports`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    });
  },
  approveScanOrder: ({ v = "v1", id = "" } = {}) =>
    instance.post(
      `/api/vendor-manager/${v}/order/approve/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
        },
      }
    ),

  rejectScanOrder: ({ v = "v1", id = "" } = {}) =>
    instance.post(
      `/api/vendor-manager/${v}/order/reject/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
        },
      }
    ),

  getVendorSetting: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor-manager/${v}/setting`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),

  createVendorSetting: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(`/api/vendor-manager/${v}/setting/create`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    });
  },

  updateVendorSetting: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/vendor-manager/${v}/setting/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
      },
    }),



  deleteVendorSetting: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/vendor-manager/${v}/setting/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorManagerAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),
};

export default apiRequest;
